import { Injectable } from '@angular/core';
import { ICommonDropdownService } from '../ui-lib/common-dropdawn/typing/common-dropdown-service.interface';
import { Params } from '@angular/router';
import { filter, map, Observable } from 'rxjs';
import { IPaginatedResponse } from '../typing/response.interface';
import { ILabelValue } from '../ui-lib/common-dropdawn/typing/label-value.interface';
import { WorkService } from './work.service';
import { IWork } from '../typing/work.interface';

@Injectable({
    providedIn: 'root'
})
export class WorkSelectorService implements ICommonDropdownService {

    constructor(private workService: WorkService) {
    }

    getList(query: Params): Observable<IPaginatedResponse<ILabelValue>> {
        return this.workService.getList(query).pipe(map(response => this.transformData(response)));
    }

    transformData(paginatedResponse: IPaginatedResponse<IWork>): IPaginatedResponse<ILabelValue> {
        const transformedData = paginatedResponse.data.map(group => ({
            label: group.name,
            value: group.id,
            tooltip: this.getTooltip(group),
        }));

        return {
            ...paginatedResponse,
            data: transformedData,
        } as IPaginatedResponse<ILabelValue>;
    }

    getOptionsByValue(optionValue: number | string): Observable<ILabelValue> {
        return this.workService.getWork(Number(optionValue)).pipe(
            filter(category => !!category),
            map(category => ({
                label: category.name as string,
                value: category.id as number,
                tooltip: category.name as string,
            })),
        );
    }

    getTooltip(value: IWork): string {
        return (value.name ? value.name : '') + (value.id ? '; id:' + value.id : '') ;
    }
}
